(function() {
  function initCountryDropdown(sectionId) {
    const section = document.querySelector('[data-section-id="' + sectionId + '"]');
    if (!section) return;

    const select = section.querySelector('#country-select-' + sectionId);
    if (!select) return;

    // Skip if already initialized
    if (select.hasAttribute('data-country-dropdown-initialized')) return;
    select.setAttribute('data-country-dropdown-initialized', 'true');

    const flagWrapper = section.querySelector('.country-dropdown__flag-wrapper');
    let flagImg = section.querySelector('[data-flag-target]');
    const contentItems = section.querySelectorAll('.country-dropdown__content-item');
    const accordionItems = section.querySelectorAll('.country-dropdown__accordions');
    const wrapper = section.querySelector('.country-dropdown__wrapper');

    // Hide native select
    select.style.position = 'absolute';
    select.style.opacity = '0';
    select.style.pointerEvents = 'none';
    select.style.width = '1px';
    select.style.height = '1px';

    // Create custom dropdown
    const customDropdown = document.createElement('div');
    customDropdown.className = 'country-dropdown__custom';
    customDropdown.setAttribute('role', 'combobox');
    customDropdown.setAttribute('aria-expanded', 'false');
    customDropdown.setAttribute('aria-haspopup', 'listbox');

    const dropdownButton = document.createElement('div');
    dropdownButton.className = 'country-dropdown__custom-button';
    dropdownButton.setAttribute('tabindex', '0');
    
    const dropdownText = document.createElement('span');
    dropdownText.className = 'country-dropdown__custom-text';
    dropdownButton.appendChild(dropdownText);

    const dropdownMenu = document.createElement('ul');
    dropdownMenu.className = 'country-dropdown__custom-menu';
    dropdownMenu.setAttribute('role', 'listbox');

    // Create search input
    const searchContainer = document.createElement('li');
    searchContainer.className = 'country-dropdown__custom-search';
    const searchInput = document.createElement('input');
    searchInput.type = 'text';
    searchInput.className = 'country-dropdown__search-input';
    searchInput.placeholder = 'SEARCH COUNTRY...';
    searchInput.setAttribute('aria-label', 'Search country');
    searchContainer.appendChild(searchInput);
    dropdownMenu.appendChild(searchContainer);

    let selectedIndex = select.selectedIndex;
    let allOptions = [];

    // Function to filter and render options
    function renderOptions(filterText = '') {
      // Clear existing options (except search)
      const existingOptions = dropdownMenu.querySelectorAll('.country-dropdown__custom-option');
      existingOptions.forEach(opt => opt.remove());

      const filterLower = filterText.toLowerCase().trim();
      
      Array.from(select.options).forEach((option, index) => {
        // Skip selected option
        if (index === selectedIndex) return;

        const blockId = option.getAttribute('data-block-id');
        const flagUrl = option.getAttribute('data-flag-url');
        const text = option.text.trim();

        // Filter by search text
        if (filterLower && !text.toLowerCase().includes(filterLower)) {
          return;
        }

        const li = document.createElement('li');
        li.className = 'country-dropdown__custom-option';
        li.setAttribute('role', 'option');
        li.setAttribute('data-value', option.value);
        li.setAttribute('data-block-id', blockId);
        li.setAttribute('data-flag-url', flagUrl || '');
        li.setAttribute('data-index', index);
        li.setAttribute('tabindex', '0');

        const flagContainer = document.createElement('div');
        flagContainer.className = 'country-dropdown__custom-option-flag';
        if (flagUrl) {
          const img = document.createElement('img');
          img.src = flagUrl;
          img.alt = text;
          img.width = 24;
          img.height = 18;
          flagContainer.appendChild(img);
        }
        li.appendChild(flagContainer);

        const textSpan = document.createElement('span');
        textSpan.className = 'country-dropdown__custom-option-text';
        textSpan.textContent = text;
        li.appendChild(textSpan);

        li.addEventListener('click', function() {
          selectedIndex = index;
          select.selectedIndex = index;
          select.dispatchEvent(new Event('change'));
          dropdownText.textContent = text;
          customDropdown.classList.remove('open');
          customDropdown.setAttribute('aria-expanded', 'false');
          searchInput.value = '';
          updateCountry(option);
          renderOptions();
        });

        dropdownMenu.appendChild(li);
      });

      allOptions = Array.from(dropdownMenu.querySelectorAll('.country-dropdown__custom-option'));
    }

    // Build initial options
    Array.from(select.options).forEach((option, index) => {
      if (option.selected) {
        selectedIndex = index;
        dropdownText.textContent = option.text.trim();
      }
    });

    renderOptions();

    // Search functionality
    searchInput.addEventListener('input', function(e) {
      e.stopPropagation();
      renderOptions(this.value);
    });

    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const firstOption = dropdownMenu.querySelector('.country-dropdown__custom-option');
        if (firstOption) firstOption.focus();
      } else if (e.key === 'Escape') {
        this.value = '';
        renderOptions();
        customDropdown.classList.remove('open');
        customDropdown.setAttribute('aria-expanded', 'false');
        dropdownButton.focus();
      }
    });

    customDropdown.appendChild(dropdownButton);
    customDropdown.appendChild(dropdownMenu);
    wrapper.appendChild(customDropdown);

    // Toggle dropdown
    dropdownButton.addEventListener('click', function(e) {
      e.stopPropagation();
      const isOpen = customDropdown.classList.toggle('open');
      customDropdown.setAttribute('aria-expanded', isOpen);
      if (isOpen) {
        searchInput.value = '';
        renderOptions();
        setTimeout(() => searchInput.focus(), 0);
      }
    });

    // Close on outside click
    document.addEventListener('click', function(e) {
      if (!customDropdown.contains(e.target)) {
        customDropdown.classList.remove('open');
        customDropdown.setAttribute('aria-expanded', 'false');
      }
    });

    // Keyboard navigation
    dropdownButton.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        customDropdown.classList.toggle('open');
        customDropdown.setAttribute('aria-expanded', customDropdown.classList.contains('open'));
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        customDropdown.classList.add('open');
        customDropdown.setAttribute('aria-expanded', 'true');
        const firstOption = dropdownMenu.querySelector('.country-dropdown__custom-option');
        if (firstOption) firstOption.focus();
      }
    });

    dropdownMenu.addEventListener('keydown', function(e) {
      // Don't interfere with search input
      if (e.target === searchInput) return;

      const options = Array.from(dropdownMenu.querySelectorAll('.country-dropdown__custom-option'));
      const currentIndex = options.findIndex(opt => opt === document.activeElement);
      
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const nextIndex = currentIndex < options.length - 1 ? currentIndex + 1 : 0;
        if (options[nextIndex]) {
          options[nextIndex].focus();
        } else if (options.length > 0) {
          options[0].focus();
        }
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const prevIndex = currentIndex > 0 ? currentIndex - 1 : options.length - 1;
        if (options[prevIndex]) {
          options[prevIndex].focus();
        } else {
          searchInput.focus();
        }
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (document.activeElement.classList.contains('country-dropdown__custom-option')) {
          document.activeElement.click();
        }
      } else if (e.key === 'Escape') {
        customDropdown.classList.remove('open');
        customDropdown.setAttribute('aria-expanded', 'false');
        searchInput.value = '';
        renderOptions();
        dropdownButton.focus();
      }
    });

    function updateCountry(optionElement) {
      const blockId = optionElement.getAttribute('data-block-id');
      const flagUrl = optionElement.getAttribute('data-flag-url');

      // Update flag
      if (flagImg && flagWrapper) {
        if (flagUrl) {
          if (flagImg.tagName === 'IMG') {
            flagImg.src = flagUrl;
            flagImg.alt = optionElement.text.trim();
          } else {
            // Replace placeholder with img
            const newImg = document.createElement('img');
            newImg.className = 'country-dropdown__flag';
            newImg.src = flagUrl;
            newImg.alt = optionElement.text.trim();
            newImg.width = 24;
            newImg.height = 24;
            newImg.setAttribute('data-flag-target', '');
            flagWrapper.replaceChild(newImg, flagImg);
            flagImg = newImg;
          }
        } else {
          // No flag image, use placeholder if currently an img
          if (flagImg.tagName === 'IMG') {
            const placeholder = document.createElement('span');
            placeholder.className = 'country-dropdown__flag-placeholder';
            placeholder.setAttribute('data-flag-target', '');
            flagWrapper.replaceChild(placeholder, flagImg);
            flagImg = placeholder;
          }
        }
      }

      // Update custom dropdown button
      dropdownText.textContent = optionElement.text.trim();
      selectedIndex = Array.from(select.options).indexOf(optionElement);

      // Hide all content items
      contentItems.forEach(item => {
        item.classList.remove('active');
      });

      // Hide all accordion items
      accordionItems.forEach(item => {
        item.classList.remove('active');
      });

      // Show selected content
      const selectedContent = section.querySelector('#block-' + blockId + '-content');
      if (selectedContent) {
        selectedContent.classList.add('active');
      }

      // Show selected accordion items
      const selectedAccordion = section.querySelector('#block-' + blockId + '-accordions');
      if (selectedAccordion) {
        selectedAccordion.classList.add('active');
      }

      // Re-render options to hide newly selected item
      if (customDropdown.classList.contains('open')) {
        renderOptions(searchInput.value);
      }
    }

    select.addEventListener('change', function() {
      const selectedOption = this.options[this.selectedIndex];
      updateCountry(selectedOption);
    });

    // Initialize on load
    const initialOption = select.options[select.selectedIndex];
    if (initialOption) {
      updateCountry(initialOption);
    }
  }

  function initAll() {
    const dropdowns = document.querySelectorAll('.country-dropdown[data-section-id]');
    dropdowns.forEach(dropdown => {
      const sectionId = dropdown.getAttribute('data-section-id');
      initCountryDropdown(sectionId);
    });
  }

  // Initialize all country dropdowns
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Also support Shopify section reloads
  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target.querySelector('.country-dropdown[data-section-id]');
    if (section) {
      const sectionId = section.getAttribute('data-section-id');
      initCountryDropdown(sectionId);
    }
  });
})();
